import React from 'react';
import { FieldError } from 'react-hook-form';
import useTranslation from '../Hooks/useTranslation';

export const useValidation = () => {
	const { t } = useTranslation();

	const messageFilled = (controlLabel: string) => {
		return controlLabel;
	};

	const fillErrorMessage = (error?: FieldError): string => {
		if (!error) {
			return '';
		}

		if (
			['is-required-select', 'required'].indexOf(error.type) !== -1 &&
			typeof error.message !== 'undefined'
		) {
			return messageFilled(t(error.message) ?? '');
		}
		return t(error.message);
	};

	const messageNumber = (controlLabel: string) => {
		return t('base.shared.form.validation.number').replace(
			'%label',
			controlLabel,
		);
	};

	return {
		messageFilled,
		messageNumber,
		fillErrorMessage,
	};
};
